import React from 'react';
import './NoRecords.scss';

export const NoRecords = (props) => {
  return (
    <div className='text-center py-5 font-24 color-aaa'>
      No records available
    </div>
  );
}